var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.721 7.88164C3.65137 8.95005 3.65137 10.6719 3.65137 14.1132V16.547C3.65137 19.9883 3.65137 21.7101 4.721 22.7786C5.78941 23.8482 7.51128 23.8482 10.9526 23.8482H18.2538C21.6951 23.8482 23.417 23.8482 24.4854 22.7786C25.555 21.7101 25.555 19.9883 25.555 16.547V14.1132C25.555 10.6719 25.555 8.95005 24.4854 7.88164C23.417 6.81201 21.6951 6.81201 18.2538 6.81201H10.9526C7.51128 6.81201 5.78941 6.81201 4.721 7.88164ZM7.97734 10.6671C7.70882 10.4879 7.38015 10.4228 7.06363 10.486C6.74711 10.5492 6.46866 10.7356 6.28954 11.0041C6.11042 11.2726 6.04531 11.6013 6.10852 11.9178C6.17174 12.2344 6.3581 12.5128 6.62661 12.6919L13.2537 17.1092C13.6534 17.3755 14.1229 17.5176 14.6032 17.5176C15.0835 17.5176 15.553 17.3755 15.9527 17.1092L22.5798 12.6919C22.8483 12.5128 23.0346 12.2344 23.0979 11.9178C23.1611 11.6013 23.096 11.2726 22.9168 11.0041C22.7377 10.7356 22.4593 10.5492 22.1428 10.486C21.8262 10.4228 21.4976 10.4879 21.229 10.6671L14.6032 15.0843L7.97734 10.6671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.69812b5691a1b103608a7973ea9dd78a.svg";
export { ForwardRef as ReactComponent };